function isChildOrDescendant(childClass, children) {
  for (let child of children || []) {
    if (child.name === childClass) {
      return true;
    }
    if (child.children && child.children.length > 0) {
      if (isChildOrDescendant(childClass, child.children)) {
        return true;
      }
    }
  }
  return false;
}

function isDescendantOf(parentClass, childClass, serviceClassTree) {
  for (let serviceClass of serviceClassTree || []) {
    if (serviceClass.name === parentClass) {
      return isChildOrDescendant(childClass, serviceClass.children);
    }
    if (isDescendantOf(parentClass, childClass, serviceClass.children)) {
      return true;
    }
  }
  return false;
}

function getPortData(port) {
  if (port && port.data && typeof port.data === 'object') return port.data;
  if (port && port.panel && port.panel.data && typeof port.panel.data === 'object') return port.panel.data;
  return {};
}

function getPortCategory(port) {
  const data = getPortData(port);
  return (port && (port.serviceClass || port.category || port.class)) ||
    data.serviceClass ||
    data.category ||
    data.class ||
    null;
}

function getPortId(port) {
  const data = getPortData(port);
  return port && port.portId !== undefined && port.portId !== null ? port.portId : data.portId;
}

function normalizePortId(portId) {
  if (portId === undefined || portId === null) return '';
  const token = String(portId);
  return token.startsWith('Port_') ? token.slice(5) : token;
}

function hasExistingFeedsLink(diagram, fromNode, fromPort, toNode, toPort) {
  if (!diagram || !diagram.links || !diagram.links.iterator) return false;

  const fromPortId = normalizePortId(getPortId(fromPort));
  const toPortId = normalizePortId(getPortId(toPort));
  var it = diagram.links.iterator;
  while (it.next()) {
    var link = it.value;
    if (!link || !link.data || link.data.class !== 'Feeds') continue;
    if (
      link.fromNode &&
      link.fromNode.key === fromNode.key &&
      normalizePortId(link.data.fromPortId) === fromPortId &&
      link.toNode &&
      link.toNode.key === toNode.key &&
      normalizePortId(link.data.toPortId) === toPortId
    ) {
      return true;
    }
  }
  return false;
}

function canCreateFeedsLink(fromNode, fromPort, toNode, toPort, serviceClassTree) {
  if (fromNode.data.category === 'Port' && toNode.data.category === 'Port') {
    return false;
  }
  const fromCategory = getPortCategory(fromPort);
  const toCategory = getPortCategory(toPort);
  if (!fromCategory || !toCategory) {
    return false;
  }
  if (
    fromCategory !== toCategory &&
    !isDescendantOf(toCategory, fromCategory, serviceClassTree)
  ) {
    return false;
  }
  if (hasExistingFeedsLink(fromNode.diagram, fromNode, fromPort, toNode, toPort)) {
    return false;
  }
  return true;
}

module.exports = {
  canCreateFeedsLink,
  isDescendantOf,
};
